module.exports = __webpack_public_path__ + "static/media/iran4.24cf199c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/panoramas/iran4.jpg
// module id = 258
// module chunks = 0